<template>
  <section>
    <h6 class="q-mb-md">Business Details:</h6>

    <div class="bg-gray q-pr-md q-pb-md q-ml-none row q-col-gutter-md">
      <div class="col-12 col-lg-6">
        <q-input
          v-model="transporterSync.companyName"
          error-message="Company name is required"
          label="Company name"
          no-error-icon
          :error="getErrorState(v.transporter.companyName)"
        />
      </div>

      <div class="col-12 col-lg-6">
        <q-input
          v-model="transporterSync.tradingName"
          error-message="Trading name is required"
          label="Trading name"
          no-error-icon
          :error="getErrorState(v.transporter.tradingName)"
        />
      </div>

      <div class="col-12 col-lg-6">
        <q-input
          v-model="transporterSync.mainOfficePhone"
          label="Main Office Phone Number"
          no-error-icon
          bottom-slots
          :error="getErrorState(v.transporter.mainOfficePhone)"
        >
          <template #error>
            <span v-if="!v.transporter.mainOfficePhone.required"> Main office phone is required </span>

            <span v-else-if="!v.transporter.mainOfficePhone.numeric">
              Main office phone must contain only numeric characters
            </span>
          </template>
        </q-input>
      </div>

      <div class="col-12 col-lg-6">
        <q-input :value="verifiedPhone" label="Verified Mobile Phone" no-error-icon bottom-slots disable> </q-input>
      </div>

      <div class="col-12 col-lg-6">
        <q-input
          v-for="(address, idx) in transporterSync.companyAddress"
          :key="idx"
          v-model="address.s"
          error-message="Company address is required"
          no-error-icon
          :error="getErrorState(v.transporter.companyAddress.$each[idx].s)"
          :label="`Company Address ${idx + 1}`"
        >
          <template v-if="idx !== 0" #append>
            <q-icon
              name="remove"
              color="negative"
              size="xs"
              class="cursor-pointer"
              @click="transporterSync.companyAddress.splice(idx, 1)"
            />
          </template>
        </q-input>

        <q-btn
          v-if="transporterSync.companyAddress.length < 4"
          dense
          flat
          icon="add"
          color="primary"
          no-caps
          label="Add address"
          @click="transporterSync.companyAddress.push({ s: '' })"
        />
      </div>

      <div class="col-12 col-lg-6">
        <q-input
          v-for="(address, idx) in transporterSync.operationalAddress"
          :key="idx"
          v-model="address.s"
          error-message="Operational address is required"
          no-error-icon
          :error="getErrorState(v.transporter.operationalAddress.$each[idx].s)"
          :label="`Operational Address ${idx + 1}`"
        >
          <template v-if="idx !== 0" #append>
            <q-icon
              name="remove"
              color="negative"
              size="xs"
              class="cursor-pointer"
              @click="transporterSync.operationalAddress.splice(idx, 1)"
            />
          </template>
        </q-input>

        <q-btn
          v-if="transporterSync.operationalAddress.length < 4"
          dense
          flat
          icon="add"
          no-caps
          color="primary"
          label="Add address"
          @click="transporterSync.operationalAddress.push({ s: '' })"
        />
      </div>

      <div class="col-12 col-lg-6">
        <q-input
          v-model="transporter.mailingAddress"
          error-message="Mailing address is required"
          no-error-icon
          :error="getErrorState(v.transporter.mailingAddress)"
          label="Mailing Address"
        >
        </q-input>
      </div>

      <div class="col-12 col-lg-6 flex items-center">
        <q-btn flat color="primary" icon="people" label="Users" @click="usersDialog = true" />
      </div>
    </div>
    <users-dialog :open.sync="usersDialog" :transporter-id="transporter.id" />
  </section>
</template>

<script>
import get from 'lodash/get';
import getErrorState from '@/utils/mixins/getErrorState';
import UsersDialog from './UsersDialog.vue';

export default {
  components: { UsersDialog },
  mixins: [getErrorState],
  props: {
    transporter: {
      type: Object,
      required: true,
    },
    v: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      usersDialog: false,
    };
  },

  computed: {
    transporterSync: {
      get() {
        return this.transporter;
      },

      set(val) {
        this.$emit('update:transporter', val);
      },
    },
    verifiedPhone() {
      return get(this.transporter, 'user.verifiedPhone.number', '');
    },
  },
};
</script>
